import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqItems.map((item) => ({
    "@type": "Question",
    "name": item.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": item.answer,
    },
  })),
};

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <section id="faq" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-4">
              FAQ
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
              Najczęściej zadawane pytania
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
              Odpowiedzi na najważniejsze pytania dotyczące Kakobuy Spreadsheet i bezpieczeństwa zakupów.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqItems.map((item, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {item.question}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`text-foreground-500 transition-transform duration-200 ${
                        openIndex === i ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </span>
                </button>
                {openIndex === i && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer no-underline"
            >
              <i className="ri-shopping-cart-line"></i>
              Przejdź do Kakobuy Spreadsheet
            </a>
          </div>
        </div>
      </section>
    </>
  );
}